import * as React from 'react';
import { shallow } from 'enzyme';
import SquareRadioButtons from './square_radio_buttons';

const testItems = ['Item 1', 'Item 2', 'Item 3'];
const onClickYield = input => {
  input.id = 'testingClick';
};

describe('<SquareRadioButtons />', () => {
  const baseComponent = shallow(
    <SquareRadioButtons
      items={testItems}
      onClickYield={onClickYield}
      vertical={true}
      radioName='test'
    />
  );

  it('renders without crashing', () => {
    expect(baseComponent).toMatchSnapshot();
  });

  it('renders the correct ids', () => {
    const expectedOutput =
      '<input type="radio" class="radioInput" id="test_0" name="test" value="Item 1"/>';
    const output = baseComponent.find('span:first-child').find('input').html();
    expect(output).toEqual(expectedOutput);
  });

  it('renders the correct labels', () => {
    const expectedOutput =
      '<span class="radio">' +
      '<input type="radio" class="radioInput" id="test_0" name="test" value="Item 1"/>' +
      '<label class="radioLabel" for="test_0"><div class="labelMain">Item 1</div></label>' +
      '</span>';
    const output = baseComponent.find('span:first-child').html();
    expect(output).toEqual(expectedOutput);
  });

  it('onClick', () => {
    const selection = baseComponent.find('span:first-child');
    const input = selection.find('input');
    const selection2 = baseComponent.find('span:last-child');
    const input2 = selection2.find('input');

    // There is no initial selection
    expect((input as any).checked).toEqual(undefined);

    // Create mock input elements that can have properties set
    const mockInput1: any = {
      checked: false,
    };
    const mockInput2: any = {
      checked: false,
    };

    // Store original document.querySelectorAll
    const originalQuerySelectorAll = document.querySelectorAll;
    
    // Mock document.querySelectorAll to return our mock inputs
    (document as any).querySelectorAll = jest.fn((selector: string) => {
      return [mockInput1, mockInput2] as any;
    });
    
    input.simulate('change', {
      currentTarget: mockInput1,
    });

    // The first element is now checked
    expect(mockInput1.id).toEqual('testingClick');
    expect(mockInput1.checked).toEqual(true);
    expect(mockInput2.checked).toEqual(false);

    input2.simulate('change', {
      currentTarget: mockInput2,
    });

    // first element is unchecked, second is checked
    expect(mockInput1.checked).toEqual(false);
    expect(mockInput2.checked).toEqual(true);
    
    // Restore original
    (document as any).querySelectorAll = originalQuerySelectorAll;
  });
});
